<template>
  <!-- CONTENT -->
  <div
    :id="'screen'"
    :style="{opacity: opacity, backgroundColor: '#040325'}"
  >
    <!-- Carousel -->
    <section
      class="center"
      :style="{display: 'flex', height: '100%'}"
    >
      <div
        class="embla"
        ref="emblaRef"
      >
        <ul class="embla__container">
          <li
            v-for="item in onboarding"
            :key="item.id"
            class="embla__slide center"
          >
            <img
              :src="item.image"
              alt="onboarding"
              :style="{width: '50%', height: '100%'}"
            />
          </li>
        </ul>
      </div>
    </section>

    <!-- Description -->
    <section
      class="container"
      :style="{marginBottom: '10%'}"
    >
      <div :style="{flexDirection: 'column'}">
        <div :style="{marginBottom: '14px'}">
          <h1 :style="{color: 'var(--white-color)'}">
            {{ onboarding[currentSlide].title1 }}
          </h1>
          <h1 :style="{color: 'var(--white-color)'}">
            {{ onboarding[currentSlide].title2 }}
          </h1>
        </div>
        <p
          :style="{color: '#B4B4C6'}"
          class="t16"
        >
          {{ onboarding[currentSlide].descriptionLine1 }}
          <br />
          {{ onboarding[currentSlide].descriptionLine2 }}
        </p>
      </div>
    </section>

    <!-- Dots -->
    <div
      class="dots container"
      :style="{marginBottom: '10%'}"
    >
      <span
        v-for="(item, index) in onboarding"
        :key="item.id"
        :class="['dot', {active: index === currentSlide}]"
        @click="scrollTo(index)"
      ></span>
    </div>

    <!-- Button -->
    <section>
      <Button
        :title="'Get Started'"
        :color-schema="'secondary'"
        @click="$router.push(routes.SIGN_IN)"
        :containerStyle="{width: '50%', padding: '0px 20px 20px 20px'}"
      />
    </section>
  </div>
</template>

<script setup>
import {ref, onMounted} from 'vue';

// other
import {routes} from '@/routes';
import {useOpacity} from '@/hooks';
import emblaCarouselVue from 'embla-carousel-vue';
import {useThemeColor} from '@/hooks/useThemeColor';

// components
import {Button} from '@/components';

useThemeColor();

const opacity = useOpacity();

const [emblaRef, emblaApi] = emblaCarouselVue();
const currentSlide = ref(0);

const scrollTo = (index) => {
  if (emblaApi.value) {
    emblaApi.value.scrollTo(index);
  }
};

onMounted(() => {
  if (emblaApi.value) {
    emblaApi.value.on('select', () => {
      currentSlide.value = emblaApi.value.selectedScrollSnap();
    });
  }
});

const onboarding = [
  {
    id: 1,
    title1: 'Welcome to Apitex',
    title2: 'bank app!',
    image: require('@/assets/onboarding/01.png'),
    descriptionLine1: 'Welcome to Apitex bank app!',
    descriptionLine2: 'You can manage your money easily.',
  },
  {
    id: 2,
    title1: 'Get a new card in a',
    title2: 'few clicks!',
    image: require('@/assets/onboarding/01.png'),
    descriptionLine1: 'Just a few clicks and',
    descriptionLine2: 'you will have a new card.',
  },
  {
    id: 3,
    title1: 'Easy payments all',
    title2: 'over the world!',
    image: require('@/assets/onboarding/01.png'),
    descriptionLine1: 'Make payments all over',
    descriptionLine2: 'the world with Apitex.',
  },
];
</script>

<style scoped>
.embla {
  overflow: hidden;
}
.embla__container {
  display: flex;
}
.embla__slide {
  flex: 0 0 100%;
  min-width: 0;
}

.dots {
  display: flex;
  flex-direction: row;
  gap: 10px;
  margin-top: 10px;
}
.dot {
  width: 20px;
  height: 2px;
  border-radius: 4px;
  background-color: #4f4f66;
  cursor: pointer;
}
.dot.active {
  background-color: var(--white-color);
}
</style>
